import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

type GraphWrapperProps = {
	children: React.ReactNode;
};

export const GraphWrapper = ({ children }: GraphWrapperProps) => (
	<Box xcss={graphWrapperStyles}>{children}</Box>
);

const graphWrapperStyles = xcss({
	position: 'relative',
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	backgroundColor: 'elevation.surface.raised',
});
